export default "__VITE_ASSET__BkV5Gupy__"